import 'classlist-polyfill'

var navPositionTop, stickyNav, scrollTop
var windowScrolled = function () {

  var navbar = document.querySelector('header')
  var steps = document.querySelector('nav.main-menu')
  const isContiki = document.querySelector('html').classList.contains('CH')
  const isDayTour = !!document.querySelector('.day-tour-flow')
  if (navbar && steps) {

    if (!stickyNav) {
      navPositionTop = steps.offsetTop
    }
    scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
    if (scrollTop > navPositionTop && !isContiki && !isDayTour) {
      stickyNav = true
      document.body.classList.add('sticky-nav')
      navbar.style.marginBottom = steps.clientHeight + 'px'
    } else {
      stickyNav = false
      document.body.classList.remove('sticky-nav')
      navbar.style.marginBottom = 0
    }
  }
}

export const bind = function () {
  window.addEventListener('scroll', windowScrolled)
  window.addEventListener('resize', windowScrolled)
}
